import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { writtenQuestions } from '../../../utils/questions';
import { Question } from '../StartTestSlice/newTemplete';

type QuestionState = {
  currentQuestionId: number;
  markedQuestions: Set<number>;
  isStartTest: boolean;
  written: Question[];
  selectedAnswers: Record<number, string>;
  questionType: string;
  answers: AnswersState;
  userTestId: string;
};

const initialState: QuestionState = {
  written: [...writtenQuestions],
  currentQuestionId: 4,
  markedQuestions: new Set(),
  isStartTest: false,
  selectedAnswers: {},
  questionType: '',
  answers: {},
  userTestId: ''
};

type AnswerType = {
  questionId: string;
  userSelectedOption: string;
  isCorrectAnswer: boolean;
  actualCorrectOption: string;
  userSubmittedCode: string;
  languageUsed: string;
  aiGeneratedAnswer: string;
  explanation: string;
};

export type AnswersState = Record<string, AnswerType[]>;

const questionSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {
    toggleMarkForReview: (state, action: PayloadAction<number>) => {
      const questionId = action.payload;
      if (state.markedQuestions.has(questionId)) {
        state.markedQuestions.delete(questionId);
      } else {
        state.markedQuestions.add(questionId);
      }
    },
    setCurrentQuestion: (state, action: PayloadAction<number>) => {
      state.currentQuestionId = action.payload;
    },
    setIsStartTest: (state, action: PayloadAction<boolean>) => {
      state.isStartTest = action.payload;
    },
    selectAnswer: (
      state,
      action: PayloadAction<{ questionNumber: number; answer: string }>
    ) => {
      state.selectedAnswers[action.payload.questionNumber] =
        action.payload.answer;
    },
    setAnswers: (state, action: PayloadAction<{ answers: AnswersState }>) => {
      state.answers = action.payload.answers;
    },
    setSectionQuestions: (state, action: PayloadAction<Question[]>) => {
      state.written = action.payload;
    },
    setUserTestId: (state, action: PayloadAction<string>) => {
      state.userTestId = action.payload;
    },
    setInitialQuestionsState: (staet, action) => {
      return action.payload;
    },
    resetState: state => {
      state.selectedAnswers = {};
    },
    resetCompleteState: state => {
      return initialState;
    }
  }
});

export const {
  toggleMarkForReview,
  setSectionQuestions,
  setCurrentQuestion,
  setIsStartTest,
  selectAnswer,
  resetState,
  setAnswers,
  setUserTestId,
  resetCompleteState,
  setInitialQuestionsState
} = questionSlice.actions;
export default questionSlice.reducer;
